<template>
  <x-dialog
    :dialogState="showDialog"
    :dialogTitle="dialogTitle"
    @toggleModal="closeDialog"
    width="50%"
    content-class="customDialog"
    :data-test-id="dataTestId"
    :actions="{
      show: false
    }"
  >
    <template slot="dialog_data">
      <loader v-if="loadingState" />
      <v-card-text flat class="px-8">
        <v-row>
          <v-tabs
            v-model="tab_active"
            grow
            :data-test-id="`${dataTestId}__user-details-form-tabs-wrapper`"
          >
            <v-tabs-slider color="#58E2C2"></v-tabs-slider>
            <v-tab v-for="(item, i) in tabItems" :key="++i" :data-test-id="`${dataTestId}__${item.dataTestId}`">
              {{ item.name }}
            </v-tab>
            <v-tabs-items v-model="tab_active">
              <v-tab-item key="1">
                <v-card flat tile class="px-8">
                  <v-row align="center" justify="start">
                    <v-col md="4" class="pl-0">
                      <span class="formInputLabel">
                        Full name
                        <span class="red--text">*</span>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-row align="center" justify="center">
                      <v-col
                        md="4"
                        class="pr-1"
                        :data-test-id="
                          `${dataTestId}__first-name-input-box-wrapper`
                        "
                      >
                        <v-text-field
                          label="First Name"
                          solo
                          filled
                          flat
                          success
                          height="52px"
                          background-color="#E5E5E5 !important"
                          autocomplete="off"
                          v-model="userModel.firstName"
                          class="fname"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        md="4"
                        class="pr-1"
                        :data-test-id="
                          `${dataTestId}__middle-name-input-box-wrapper`
                        "
                      >
                        <v-text-field
                          label="Middle Name"
                          solo
                          filled
                          flat
                          success
                          height="52px"
                          background-color="#E5E5E5 !important"
                          autocomplete="off"
                          v-model="userModel.middleName"
                          class="fname"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        md="4"
                        :data-test-id="
                          `${dataTestId}__last-name-input-box-wrapper`
                        "
                      >
                        <v-text-field
                          label="Last Name"
                          solo
                          filled
                          flat
                          height="52px"
                          background-color="#E5E5E5 !important"
                          autocomplete="off"
                          v-model="userModel.lastName"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-row>
                  <v-row align="center">
                    <v-col md="4" class="pl-0">
                      <span class="formInputLabel">
                        Primary email address
                        <span class="red--text">*</span>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row
                    :data-test-id="`${dataTestId}__email-input-box-wrapper`"
                  >
                    <v-text-field
                      label="firstname.lastname@xift.com"
                      solo
                      filled
                      flat
                      height="52px"
                      background-color="#E5E5E5 !important"
                      v-model="userModel.primaryEmail"
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-col md="8" class="pl-0">
                      <span class="formInputLabel">Email aliases</span>
                    </v-col>
                  </v-row>
                  <v-row
                    align="center"
                    v-for="(item, index) in addUserData.email_Alias"
                    :key="item.id"
                  >
                    <v-row align="center">
                      <v-col
                        md="7"
                        :data-test-id="
                          `${dataTestId}__email-alias-${index +
                            1}-input-box-wrapper`
                        "
                      >
                        <v-text-field
                          @input="validateEmail(item)"
                          label="type email alias then press + to add"
                          solo
                          filled
                          :id="item.id"
                          flat
                          height="52px"
                          background-color="#E5E5E5 !important"
                          v-model="item.val"
                          width="80%"
                        ></v-text-field>
                      </v-col>
                      <v-col md="1" class="text-center">
                        <v-icon
                          v-if="item.validateEmailIcon"
                          color="#58E2C2"
                          size="25"
                          :id="item.id"
                        >
                          done
                        </v-icon>
                        <v-icon
                          v-if="item.errorValidate"
                          color="red"
                          size="25"
                          :id="item.id"
                          :data-test-id="
                            `${dataTestId}__email-alias-${index +
                              1}__clear-icon`
                          "
                          @click="removeAlias(item)"
                        >
                          clear
                        </v-icon>
                      </v-col>
                      <v-col md="1" class="text-center">
                        <v-icon
                          v-if="item.addNewAliasIconVisible"
                          color="#58E2C2"
                          size="25"
                          :disabled="item.addNewAliasIcon || item.val === ''"
                          :data-test-id="
                            `${dataTestId}__email-alias-${index + 1}__add-icon`
                          "
                          @click="addAlias"
                        >
                          add
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item key="2">
                <v-card tile flat class="px-8">
                  <v-row align="center">
                    <v-col md="3" class="pl-0">
                      <span class="formInputLabel">Telephone</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <vue-tel-input
                      v-model="userModel.telephone"
                      v-bind="bindProps"
                      :class="telClass"
                      :data-test-id="
                        `${dataTestId}__telephone-input-box-wrapper`
                      "
                      @validate="phoneNumberValidation"
                      @onInput="phoneNumberValidation"
                    ></vue-tel-input>
                  </v-row>
                  <v-row align="center">
                    <v-col md="3" class="pl-0">
                      <span class="formInputLabel">Street Address</span>
                    </v-col>
                  </v-row>
                  <v-row
                    :data-test-id="`${dataTestId}__street-input-box-wrapper`"
                  >
                    <v-text-field
                      solo
                      filled
                      flat
                      height="52px"
                      background-color="#E5E5E5 !important"
                      v-model="userModel.addresses.streetAddress"
                    ></v-text-field>
                  </v-row>
                  <v-row align="center">
                    <v-col md="3" class="pl-0">
                      <span class="formInputLabel">Locality</span>
                    </v-col>
                  </v-row>
                  <v-row
                    :data-test-id="`${dataTestId}__locality-input-box-wrapper`"
                  >
                    <v-text-field
                      solo
                      filled
                      flat
                      height="52px"
                      background-color="#E5E5E5 !important"
                      v-model="userModel.addresses.locality"
                    ></v-text-field>
                  </v-row>
                  <v-row align="center">
                    <v-col md="3" class="pl-0">
                      <span class="formInputLabel">County/City</span>
                    </v-col>
                  </v-row>
                  <v-row
                    :data-test-id="`${dataTestId}__city-input-box-wrapper`"
                  >
                    <v-text-field
                      solo
                      filled
                      flat
                      height="52px"
                      background-color="#E5E5E5 !important"
                      v-model="userModel.addresses.region"
                    ></v-text-field>
                  </v-row>
                  <v-row align="center">
                    <v-col md="3" class="pl-0">
                      <span class="formInputLabel">Country</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <country-select
                      class="country-select"
                      v-model="userModel.addresses.country"
                      topCountry="GB"
                      :data-test-id="
                        `${dataTestId}__country-select-box-wrapper`
                      "
                    />
                  </v-row>
                  <v-row align="center">
                    <v-col md="3" class="pl-0">
                      <span class="formInputLabel">Postcode</span>
                    </v-col>
                  </v-row>
                  <v-row
                    :data-test-id="
                      `${dataTestId}__postal-code-input-box-wrapper`
                    "
                  >
                    <v-text-field
                      solo
                      filled
                      flat
                      height="52px"
                      background-color="#E5E5E5 !important"
                      v-model="userModel.addresses.postalCode"
                    ></v-text-field>
                  </v-row>
                  <v-row align="center">
                    <v-col md="3" class="pl-0">
                      <span class="formInputLabel">Job Title</span>
                    </v-col>
                  </v-row>
                  <v-row
                    :data-test-id="`${dataTestId}__job-title-input-box-wrapper`"
                  >
                    <v-text-field
                      solo
                      filled
                      flat
                      height="52px"
                      background-color="#E5E5E5 !important"
                      v-model="userModel.jobTitle"
                    ></v-text-field>
                  </v-row>
                  <v-row align="center">
                    <v-col md="3" class="pl-0">
                      <span class="formInputLabel">Department</span>
                    </v-col>
                  </v-row>
                  <v-row
                    :data-test-id="
                      `${dataTestId}__department-input-box-wrapper`
                    "
                  >
                    <v-text-field
                      solo
                      filled
                      flat
                      height="52px"
                      background-color="#E5E5E5 !important"
                      v-model="userModel.department"
                    ></v-text-field>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-10 py-7">
        <v-row justify="end">
          <x-button
            outline
            color="#58E2C2"
            buttonText="Cancel"
            :data-test-id="`${dataTestId}__cancel-btn`"
            @click="closeDialog"
          />
          <v-spacer class="asdf"></v-spacer>
          <x-button
            v-if="tab_active !== 0"
            color="#58E2C2"
            buttonText=" Previous"
            :data-test-id="`${dataTestId}__prev-btn`"
            @click="prev"
          />
          <x-button
            v-if="tab_active !== 1"
            color="#58E2C2"
            buttonText=" Next"
            class="ml-2"
            :data-test-id="`${dataTestId}__next-btn`"
            @click="next"
          />
          <x-button
            v-if="tab_active === 1"
            color="#58E2C2"
            buttonText="Save Changes"
            class="ml-2"
            :data-test-id="`${dataTestId}__save-btn`"
            @click="saveVal"
          />
        </v-row>
      </v-card-actions>
    </template>
  </x-dialog>
</template>

<script>
var findIndex = require('lodash.findindex');
import { VueTelInput } from 'vue-tel-input';
import UserService from '../../../services/UserService';

export default {
  components: {
    VueTelInput
  },
  props: { addUserDialog: Boolean, dataTestId: String },
  data() {
    return {
      bindProps: {
        mode: 'international',
        defaultCountry: 'GB'
      },
      showDialog: false,
      currentTab: 0,
      userModel: {
        userId: '',
        orgId: this.currentlySelectedOrgId,
        firstName: '',
        middleName: '',
        lastName: '',
        primaryEmail: '',
        secondaryEmails: [],
        license: 'company',
        roles: ['USER'],
        status: 'ACTIVE',
        alias: '',
        jobTitle: '',
        department: '',
        telephone: '',
        addresses: {
          country: '',
          locality: '',
          postalCode: '',
          region: '',
          streetAddress: ''
        }
      },
      showAlert: true,
      rules: {
        length: len => v =>
          (v || '').length >= len ||
          `Invalid character length, required ${len}`,
        password: v =>
          (v || '').match(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/
          ) ||
          'Password must contain an upper case letter, a numeric character, and a special character'
      },
      dialogTitle: 'Add new account',
      tab_active: null,
      addUserData: {
        email_Alias: [
          {
            id: 'alias0',
            val: '',
            label: 'Email aliases:',
            status: false,
            validateEmailIcon: false,
            errorValidate: false,
            addNewAliasIcon: false,
            addNewAliasIconVisible: true
          }
        ],
        external_Id: ''
      },
      tabItems: [
        {
          id: 1,
          name: 'Account details',
          dataTestId: 'account-details'
        },
        {
          id: 2,
          name: 'Additional details',
          dataTestId: 'additional-details'
        }
      ],
      min_length: 1,
      counter: 0,
      addNewAliasIcon: true,
      prevBtn: false,
      nextBtn: false,
      saveBtn: false,
      plusIcon: true,
      telClass: '',
      loadingState: false
    };
  },
  created: function() {
    this.emailAliasLimit = 100;
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  mounted: function() {
    this.showDialog = this.addUserDialog;
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  methods: {
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.showDialog) {
        this.closeDialog();
      }
    },
    changeTab(id) {
      this.currentTab = id;
      this.tab_active = 'tab-' + (id - 1);
    },
    validateEmail(email) {
      for (
        let index = 0;
        index < this.addUserData.email_Alias.length;
        index++
      ) {
        const element = this.addUserData.email_Alias[index];
        element.addNewAliasIcon = true;
      }
      let temp = this.emailValidate(email.val);
      let indexVal = findIndex(this.addUserData.email_Alias, function(o) {
        return o.id === email.id;
      });
      if (temp) {
        this.addUserData.email_Alias[indexVal].status = true;
        this.addUserData.email_Alias[indexVal].val = email.val;
        this.addUserData.email_Alias[indexVal].validateEmailIcon = true;
        this.addUserData.email_Alias[indexVal].errorValidate = false;
        this.addUserData.email_Alias[indexVal].addNewAliasIcon = false;
        if (this.addUserData.email_Alias.length === this.min_length) {
          this.addUserData.email_Alias[0].addNewAliasIconVisible = true;
        }
      } else {
        this.addUserData.email_Alias[indexVal].status = false;
        this.addUserData.email_Alias[indexVal].val = email.val;
        this.addUserData.email_Alias[indexVal].validateEmailIcon = false;
        this.addUserData.email_Alias[indexVal].errorValidate = true;
        this.addUserData.email_Alias[indexVal].addNewAliasIcon = true;
      }
    },
    addAlias() {
      for (
        let index = 0;
        index < this.addUserData.email_Alias.length;
        index++
      ) {
        const element = this.addUserData.email_Alias[index];
        element.addNewAliasIcon = true;
        element.addNewAliasIconVisible = false;
      }
      if (this.addUserData.email_Alias.length < this.emailAliasLimit) {
        this.addUserData.email_Alias.push({
          id: `alias${++this.counter}`,
          label: '',
          value: '',
          status: false,
          validateEmailIcon: false,
          errorValidate: false,
          addNewAliasIcon: true,
          addNewAliasIconVisible: true
        });
      } else {
        alert('you have reached maximum limit');
      }
    },
    removeAlias(item) {
      if (this.addUserData.email_Alias.length === this.min_length) {
        item.val = '';
        item.errorValidate = false;
        item.addNewAliasIconVisible = true;
        return;
      }
      let index = this.addUserData.email_Alias.indexOf(item);
      if (index !== -1) {
        this.addUserData.email_Alias.splice(index, 1);
      }
      let last_index = this.addUserData.email_Alias.length;
      if (!this.addUserData.email_Alias[last_index - 1].errorValidate) {
        this.addUserData.email_Alias[
          last_index - 1
        ].addNewAliasIconVisible = true;
        this.addUserData.email_Alias[last_index - 1].addNewAliasIcon = false;
      }
    },
    closeDialog(refreshUsers = false, refreshSummary = false) {
      this.$emit('closeOverlay', {
        refreshUsers: refreshUsers,
        refreshSummary: refreshSummary
      });
      this.showDialog = false;
    },
    next() {
      const tab = parseInt(this.tab_active);
      this.tab_active = tab + 1;
    },
    prev() {
      const tab = parseInt(this.tab_active);
      this.tab_active = tab - 1;
    },
    populateUserModel() {
      let aliasesName = [];
      this.addUserData.email_Alias.forEach(element => {
        return aliasesName.push(element.val);
      });
      aliasesName = aliasesName.filter(alias => alias);
      this.userModel.secondaryEmails = aliasesName;
      this.userModel.orgId = this.currentlySelectedOrgId;
    },
    async saveVal() {
      try {
        this.loadingState = true;
        this.populateUserModel();
        let createUserResponse = await UserService.createUser(this.userModel);
        if (createUserResponse.error) {
          this.snackbar('error', this.$message.ACCOUNT_CREATE_ERROR);
          return false;
        }
        this.snackbar('success', this.$message.ACCOUNT_CREATED);
        this.closeDialog(true, true);
      } catch (err) {
        this.snackbar('error', err);
      } finally {
        this.loadingState = false;
      }
    }
  },
  beforeDestroy() {}
};
</script>

<style scoped>
.vue-tel-input:focus-within {
  box-shadow: none;
  border-color: transparent;
}
.is-invalid {
  border-color: red;
}
.is-valid {
  border-color: #58e2c2;
}
.user-tab {
  box-shadow: none;
}

.fname > div.v-input__control {
  padding-right: 10px !important;
}

.user-dropdown {
  background: rgb(229, 229, 229) !important;
  border-color: rgb(229, 229, 229) !important;
}

.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 0 !important;
}
</style>

<style scoped></style>
